<template>
  <div class="employee">
    <div class="time-sheet__filter">
      <div class="time-sheet__header">Danh sách đơn OT</div>
      <div class="card-table-emloyee">
        <CRow class="mx-0">
          <CCol sm="4" lg="3" md="3" xl="2" class="pr-3 px-0">
            <div>
              <label class="month">Tháng</label>
              <a-month-picker
                class="datepicker__input"
                placeholder="Tháng"
                format="MM/YYYY"
                v-model="searchData.month"
                :disabled-date="disableMonth"
                @change="search"
                :allowClear="false"
              />
            </div>
          </CCol>
          <CCol sm="4" lg="3" md="3" xl="2" class="pl-0 pr-3">
            <div>
              <label>{{ $t("commons.label_status") }}</label>
              <select
                class="form-control"
                v-model="searchData.status"
                @change="search"
              >
                <option value="0">
                  {{ $t("employee.select_all_option") }}
                </option>
                <option value="1" class="employee__badge color-status-1">
                  {{ $t("commons.label_status_overtime_request_1") }}
                </option>
                <option value="2" class="employee__badge color-status-2">
                  {{ $t("commons.label_status_overtime_request_2") }}
                </option>
                <option value="3" class="employee__badge color-status-3">
                  {{ $t("commons.label_status_overtime_request_3") }}
                </option>
              </select>
            </div>
          </CCol>
          <CCol sm="4" lg="3" md="3" class="btn-search px-0">
            <CButton class="btn-search-employee" @click.prevent="search">
              <img src="../../assets/icons/icon-search-white.svg" alt="" />
              {{ $t("button.label_employee_btn_search") }}
            </CButton>
          </CCol>
        </CRow>
      </div>
    </div>
    <div class="wrapper">
      <over-time-request-tab :tab="1">
        <template v-slot:button-create>
          <div
            class="btn-switch-link"
            @click="$refs.createOverTime.showModal()"
          >
            <img src="../../assets/icons/icon_plus.svg" alt="" />
            <span> Thêm đơn OT</span>
          </div>
        </template>
        <template v-slot:data-table>
          <div class="table-wrapper">
            <table class="table-content">
              <thead class="table-header">
                <tr>
                  <th class="cl-pointer" width="10%">
                    {{ $t("employee.label_employee_over_time_date") }}
                  </th>
                  <th class="cl-pointer" width="15%">
                    {{ $t("commons.label_project_name") }}
                  </th>
                  <th class="cl-pointer" width="10%">
                    {{ $t("employee.label_employee_request_ot") }}
                  </th>

                  <th width="10%">
                    {{ $t("commons.label_time_ot_real") }}
                  </th>
                  <th width="7%">
                    {{ $t("commons.timesheet_real") }}
                  </th>
                  <th width="7%">
                    {{ $t("commons.sabbatical_real") }}
                  </th>
                  <th width="15%">
                    {{ $t("commons.label_status_confirm") }}
                  </th>
                  <th>Ngày tạo</th>
                  <th width="7%">
                    {{ $t("commons.label_status") }}
                  </th>
                  <th width="7%">
                    {{ $t("commons.label_action") }}
                  </th>
                </tr>
              </thead>
              <tbody class="table-body">
                <template
                  v-if="
                    overTimeRequests.data && overTimeRequests.data.length > 0
                  "
                >
                  <tr
                    v-for="(item, index) in overTimeRequests.data"
                    :key="index"
                  >
                    <td>
                      <div>{{ $t(`date.${getDate(item.date)}`) }}</div>
                      <div>{{ item.date | formatDate }}</div>
                    </td>
                    <td>{{ item.project_name }}</td>
                    <td>
                      {{ formatDate(item.start_time) }} -
                      {{ formatDate(item.end_time) }}
                    </td>
                    <td :style="item.durationReal === '00:00'  && 'color:#f58722;font-weight:bold'">{{ item.durationReal }}</td>
                    <td :style="item.durationReal === '00:00'  && 'color:#f58722;font-weight:bold'">{{ formatNumber(item.actualNumber) }}</td>
                    <td :style="item.durationReal === '00:00'  && 'color:#f58722;font-weight:bold'">{{ formatNumber(item.actualLeaveDay) }}</td>
                    <td>
                      <ul>
                        <li
                          v-for="(
                            employeeApproval, key
                          ) in item.over_time_request_approves"
                          :key="key"
                          class="text-left px-4"
                        >
                          <template
                            v-if="
                              parseInt(item.id) ===
                              parseInt(employeeApproval.over_time_request_id)
                            "
                          >
                            {{
                              employeeApproval.level === 1
                                ? employeeApproval.employees[0].name
                                : employeeApproval.employees[0].name
                            }}
                            :
                            {{
                              $t(
                                `overtime.employee_approval_${employeeApproval.status}`
                              )
                            }}
                          </template>
                        </li>
                      </ul>
                    </td>
                    <td>
                    {{ item.created_at | formatDateTime }}
                  </td>
                    <td>
                      <span
                        v-bind:class="
                          item.status ? 'color-status-' + item.status : ''
                        "
                        class="status-content"
                        >{{
                          $t(
                            `commons.label_status_overtime_request_${item.status}`
                          )
                        }}
                      </span>
                    </td>
                    <td>
                      <!-- <router-link
                        :to="{ path: `/overtime-requests/detail/${item.id}` }"
                      >
                        <CButton color="info" variant="outline" square size="sm"
                          >{{ $t("button.label_action_show") }}
                        </CButton>
                      </router-link>
                      <span class="mr-1"></span>
                      <router-link
                        :to="{
                          path: `/overtime-requests/update/${item.id}`,
                          params: { id: item.id },
                        }"
                        tag="a"
                      >
                        <CButton
                          v-if="item.status == 1 && checkValidDate(item.date)"
                          disable
                          color="primary"
                          variant="outline"
                          square
                          size="sm"
                          >{{ $t("button.label_action_edit") }}
                        </CButton>
                      </router-link>
                      <span class="mr-1"></span> -->
                      <div class="action-btn-group">
                        <div
                          class="action-button"
                          @click="$refs.editOverTime.showModal(item.id,item.status , checkValidDate(item.date))"
                        >
                          <img
                            src="../../assets/icons/pencil-icon.svg"
                            alt=""
                          />
                        </div>
                        <div
                          v-if="item.editable"
                          disable
                          class="action-button"
                          @click="deleteItem(item.id)"
                        >
                          <img src="../../assets/icons/trash.svg" alt="" />
                        </div>
                      </div>
                    </td>
                  </tr>
                </template>
                <template v-else>
                  <tr>
                    <td colspan="12" class="text-center">
                      <a-empty
                        :image="simpleImage"
                        :description="description"
                      />
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
          <CPagination
            v-if="overTimeRequests.data && overTimeRequests.data.length > 0"
            :activePage.sync="searchData.paginate.currentPage"
            :pages="searchData.paginate.totalPage"
            @update:activePage="changePage"
            size="sm"
            align="center"
          />
        </template>
      </over-time-request-tab>
      <CreateOverTimeModal @fetchData="getLists" ref="createOverTime" />
      <EditOverTimeModal
        @fetchData="getLists"
        :id="idDelete"
        ref="editOverTime"
      />
      <a-modal
        v-model="visible"
        title="Xác nhận xóa đơn OT"
        :centered="true"
        :footer="null"
        :width="684"
        :zIndex="1030"
      >
        <div class="remove-ot-request">
          <div class="content">
            <img src="../../assets/icons/note.svg" alt="" />
            <p>Bạn có chắc chắn thực hiện hành động này không ?</p>
          </div>

          <CRow class="form-button">
            <CCol md="12" class="employees-form-ot">
              <CButton type="submit" class="save-info" @click="confirmDelete()"
                >{{ $t("button.label_action_accept") }}
              </CButton>
              <CButton class="cancel-employee" type="button" @click="cancel()"
                >{{ $t("commons.cancel") }}
              </CButton>
            </CCol>
          </CRow>
        </div>
      </a-modal>
    </div>
    <!-- <CCard class="employee-table">
      <CCardBody>
        <div class="tabs-control-overtime-request">
          <div class="time-sheet__header">Danh sách đơn OT</div>
          <div class="time-sheet__button">
            <router-link
              class="router_button"
              :to="{ path: `/overtime-requests/create` }"
            >
              <div class="overtime-request__create">
                <img src="../../assets/icons/icon_plus.svg" alt="" />Thêm đơn OT
              </div>
            </router-link>
          </div>
        </div>
        <ul class="list-tabs">
          <li class="active">
            {{ $t("fields.overtime.label_my") }}
          </li>
          <router-link to="/overtime-requests/approval">
            <li>
              {{ $t("fields.overtime.label_disapproval") }}
            </li>
          </router-link>
        </ul>

        <div class="table-responsive">
          <table class="table">
            <thead>
              <tr>
                <th>#</th>
                <th class="cl-pointer" @click="sortByColumn(columnSort.date)">
                  {{ $t("employee.label_employee_over_time_date") }}
                  <span class="icon-sort">
                    <CIcon
                      name="cil-caret-bottom"
                      :class="classStatusSort(columnSort.date)"
                    ></CIcon>
                  </span>
                </th>
                <th
                  class="cl-pointer"
                  @click="sortByColumn(columnSort.project_name)"
                >
                  {{ $t("commons.label_project_name") }}
                </th>
                <th
                  class="cl-pointer"
                  @click="sortByColumn(columnSort.start_time)"
                >
                  {{ $t("employee.label_employee_request_time") }}
                  <span class="icon-sort">
                    <CIcon
                      name="cil-caret-bottom"
                      :class="classStatusSort(columnSort.start_time)"
                    ></CIcon>
                  </span>
                </th>
                <th
                  class="cl-pointer"
                  @click="sortByColumn(columnSort.end_time)"
                >
                  {{ $t("employee.label_employee_real_time") }}
                  <span class="icon-sort">
                    <CIcon
                      name="cil-caret-bottom"
                      :class="classStatusSort(columnSort.end_time)"
                    ></CIcon>
                  </span>
                </th>
                <th>
                  {{ $t("commons.label_time_ot_real") }}
                </th>
                <th>
                  {{ $t("commons.timesheet_real") }}
                </th>
                <th>
                  {{ $t("commons.sabbatical_real") }}
                </th>
                <th>
                  {{ $t("commons.label_status") }}
                </th>
                <th>
                  {{ $t("commons.label_action") }}
                </th>
              </tr>
            </thead>
            <tbody>
              <template
                v-if="overTimeRequests.data && overTimeRequests.data.length > 0"
              >
                <tr v-for="(item, index) in overTimeRequests.data" :key="index">
                  <th scope="row">{{ index + 1 }}</th>
                  <td>{{ item.date | formatDate }}</td>
                  <td>{{ item.project_name }}</td>
                  <td>
                    {{ formatDate(item.start_time) }} -
                    {{ formatDate(item.end_time) }}
                  </td>
                  <td>
                    {{ formatDate(item.start_time_real) }} -
                    {{ formatDate(item.end_time_real) }}
                  </td>
                  <td>{{ item.durationReal }}</td>
                  <td>{{ item.actualNumber }}</td>
                  <td>{{ item.actualLeaveDay }}</td>
                  <td
                    v-bind:class="
                      item.status ? 'color-status-' + item.status : ''
                    "
                  >
                    <CBadge color="secondary"
                      >{{
                        $t(
                          `commons.label_status_overtime_request_${item.status}`
                        )
                      }}
                    </CBadge>
                  </td>
                  <td class="min-w-200">
                    <router-link
                      :to="{ path: `/overtime-requests/detail/${item.id}` }"
                    >
                      <CButton color="info" variant="outline" square size="sm"
                        >{{ $t("button.label_action_show") }}
                      </CButton>
                    </router-link>
                    <span class="mr-1"></span>
                    <router-link
                      :to="{
                        path: `/overtime-requests/update/${item.id}`,
                        params: { id: item.id },
                      }"
                      tag="a"
                    >
                      <CButton
                        v-if="item.status == 1 && checkValidDate(item.date)"
                        disable
                        color="primary"
                        variant="outline"
                        square
                        size="sm"
                        >{{ $t("button.label_action_edit") }}
                      </CButton>
                    </router-link>
                    <span class="mr-1"></span>
                    <CButton
                      v-if="item.status == 1 && checkValidDate(item.date)"
                      disable
                      color="danger"
                      variant="outline"
                      square
                      size="sm"
                      @click="deleteItem(item.id)"
                      >{{ $t("button.label_action_delete") }}
                    </CButton>
                  </td>
                </tr>
              </template>
              <template v-else>
                <tr>
                  <td colspan="12" class="text-center">
                    {{ $t("table.label_data_not_found") }}
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </CCardBody>

    </CCard> -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import OverTimeRequestTab from "./OverTimeRequestTab.vue";
import CreateOverTimeModal from "./components/CreateOverTimeModal.vue";
import EditOverTimeModal from "./components/EditOverTimeModal.vue";
import { Empty } from "ant-design-vue";
import moment from "moment";

export default {
  name: "Overtime",
  metaInfo() {
    return {
      title: this.$t("page_title.page_overtime_request_list"),
      titleTemplate: "%s | " + this.$t("page_title.head_title"),
    };
  },
  data() {
    return {
      idDelete: null,
      visible: false,
      description: this.$t("table.label_data_not_found"),
      over_time_request_approves: [],
      listMyOvertime: [],
      listDisapprovalOvertime: [],
      listTabs: [
        {
          name: "MyOvertime",
          title: this.$t("overtime.label_my"),
        },
        {
          name: "DisapprovalOvertime",
          title: this.$t("overtime.label_disapproval"),
        },
      ],
      currentTab: 0,
      searchData: {
        // startDate: null,
        // endDate: null,
        // projectId: 0,
        approvePerson: "",
        status: 0,
        itemsPerPage: 10,
        sortColumn: "date",
        sortBy: "DESC",
        month: moment(),
        paginate: {
          from: 0,
          to: 0,
          totalPage: 0,
          path: "",
          currentPage: 1,
          totalRecord: 0,
          perPage: 0,
        },
      },
      columnSort: {
        project_name: "project_name",
        date: "date",
        start_time: "start_time",
        end_time: "end_time",
      },
      componentKey: 0,
    };
  },
  computed: {
    ...mapGetters({
      overTimeRequests: "overtime-request/overTimeRequests",
      commonProjects: "overtime-request/commonProjects",
      listItemsPerPage: "commons/listItemsPerPage",
      pagination: "overtime-request/pagination",
      checkSubmitable: "commons/sumittedInfomation",
    }),
  },
  components: {
    OverTimeRequestTab,
    CreateOverTimeModal,
    EditOverTimeModal,
  },

  beforeCreate() {
    this.simpleImage = Empty.PRESENTED_IMAGE_SIMPLE;
  },

  methods: {
    ...mapActions("overtime-request", [
      "listOverTimeRequest",
      "deleteOverTimeRequest",
    ]),
    cancel() {
      this.visible = false;
    },
    changeTab(tab) {
      this.currentTab = tab;
    },
    startDate(data) {
      this.searchData.startDate = data;
    },
    endDate(data) {
      this.searchData.endDate = data;
    },
    forceRerender() {
      this.componentKey += 1;
    },
    resetForm() {
      // this.searchData.startDate = this.getDateSearch().firstDay;
      // this.searchData.endDate = this.getDateSearch().lastDay;
      this.forceRerender();
      // this.searchData.projectId = 0;
      this.searchData.approvePerson = "";
      this.searchData.status = 0;
      localStorage.removeItem("startDateOT");
      localStorage.removeItem("endDateOT");
      localStorage.removeItem("statusOT");
      localStorage.removeItem("approvePersonOT");
    },

    async getLists() {
      this.$root.$loading.start();
      if (
        this.searchData.sortBy !== "DESC" &&
        this.searchData.sortBy !== "ASC"
      ) {
        this.searchData.sortBy = "DESC";
      }
      await this.listOverTimeRequest({
        currentPage: this.searchData.paginate.currentPage,
        status: parseInt(this.searchData.status),
        sortColumn: this.searchData.sortColumn,
        sortBy: this.searchData.sortBy,
        month: this.searchData.month.format("MM/YYYY"),
      });
      this.searchData.paginate = this.pagination;
      this.$root.$loading.finish();
      // this.over_time_request_approves = [];
      // for (let index of this.overTimeRequests.data) {
      //   if (index.over_time_request_approves.length > 1) {
      //     for (let key in index.over_time_request_approves) {
      //       if (
      //         parseInt(index.over_time_request_approves[0].employee_id) !==
      //         parseInt(index.over_time_request_approves[1].employee_id)
      //       ) {
      //         this.over_time_request_approves.push(
      //           index.over_time_request_approves[key]
      //         );
      //       } else if (
      //         parseInt(index.over_time_request_approves[0].employee_id) ===
      //         parseInt(index.over_time_request_approves[1].employee_id)
      //       ) {
      //         this.over_time_request_approves.push(
      //           index.over_time_request_approves[key]
      //         );
      //         break;
      //       }
      //     }
      //   } else {
      //     this.over_time_request_approves.push(
      //       index.over_time_request_approves[0]
      //     );
      //   }
      // }
    },

    async search() {
      // if (this.$route.fullPath !== "/overtime-requests") {
      //   this.clearParamUrl();
      // }
      // localStorage.setItem("approvePersonOT", this.searchData.approvePerson);
      // localStorage.setItem("statusOT", this.searchData.status);
      // localStorage.setItem("startDateOT", this.searchData.startDate);
      // localStorage.setItem("endDateOT", this.searchData.endDate);
      // localStorage.setItem("monthOT", this.searchData.month);

      this.searchData.paginate.currentPage = 1;
      this.passParamUrl();
      this.$root.$loading.start();
      try {
        await this.getLists();
        this.$root.$loading.finish();
      } catch {
        this.$root.$loading.finish();
      }
    },

    showPopupApprove() {
      this.$confirm(
        this.$t("popup.overtime.label_popup_approve_message"),
        this.$t("popup.overtime.label_popup_approve_title"),
        this.$t("popup.overtime.label_popup_title_confirm"),
        this.$t("popup.overtime.label_cancel_button"),
        "danger"
      ).then((value) => {
        if (value) {
          this.forms.status = 2;
          this.submitOverTimeRequest();
        }
      });
    },

    showPopupCancel() {
      this.$confirm(
        this.$t("popup.overtime.label_popup_reject_message"),
        this.$t("popup.overtime.label_popup_approve_title"),
        this.$t("popup.overtime.label_popup_title_cancel_approve"),
        this.$t("popup.overtime.label_cancel_button"),
        "danger"
      ).then((value) => {
        if (value) {
          this.forms.status = 3;
          this.submitOverTimeRequest();
        }
      });
    },

    objectNotNull(obj) {
      if (obj) {
        return Object.keys(obj).length !== 0;
      }
    },

    getDateSearch() {
      let date = new Date();
      let currentDay = moment(date).format("YYYY-MM-DD");
      let firstDay = "";
      if (
        moment(new Date(date.getFullYear(), date.getMonth(), 1)).format(
          "YYYY-MM-DD"
        ) <= currentDay &&
        currentDay <=
          moment(new Date(date.getFullYear(), date.getMonth(), 5)).format(
            "YYYY-MM-DD"
          )
      ) {
        firstDay = new Date(date.getFullYear(), date.getMonth() - 1, 1);
      }
      if (
        currentDay >
        moment(new Date(date.getFullYear(), date.getMonth(), 5)).format(
          "YYYY-MM-DD"
        )
      ) {
        firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
      }
      return {
        firstDay: Intl.DateTimeFormat("en-GB").format(firstDay),
        lastDay: "",
      };
    },

    checkDataParam(data) {
      return data === 0 || data === "" ? undefined : data;
    },

    passParamUrl() {
      this.$router.push({
        name: "Overtime Request",
        query: {
          month: this.checkDataParam(
            moment(this.searchData.month).format("MM/YYYY")
          ),
          status: this.checkDataParam(parseInt(this.searchData.status)),
          currentPage: this.checkDataParam(
            this.searchData.paginate.currentPage
          ),
          perPage: this.checkDataParam(this.searchData.itemsPerPage),
          sortColumn: this.checkDataParam(this.searchData.sortColumn),
          sortBy: this.checkDataParam(this.searchData.sortBy),
        },
      });
    },

    clearParamUrl() {
      this.$router.push({ name: "Overtime Request" });
    },

    convertParamsDate(date) {
      if (!date) return "";
      let d = moment(date, "DD/MM/YYYY");
      return d.format("DD-MM-YYYY");
    },

    reverseParamsDate(date) {
      if (!date) return "";
      let d = moment(date, "DD-MM-YYYY");
      return d.format("DD/MM/YYYY");
    },

    checkParamIsDate(date) {
      return moment(date, "DD-MM-YYYY", true).isValid();
    },

    resetParams() {
      if (this.$route.fullPath !== "/overtime-requests") {
        this.clearParamUrl();
      }
      this.searchData = {
        month: moment(),
        status: 0,
        itemsPerPage: 10,
        sortColumn: "date",
        sortBy: "DESC",
        paginate: {
          from: 0,
          to: 0,
          totalPage: 0,
          path: "",
          currentPage: 1,
          totalRecord: 0,
          perPage: 0,
        },
      };
    },

    changePage(page) {
      this.passParamUrl();
      this.getLists(this.searchData.itemsPerPage, page);
    },

    sortByColumn(column) {
      if (this.searchData.sortColumn != column) {
        this.searchData.sortBy = "DESC";
      }
      this.searchData.sortColumn = column;
      this.searchData.sortBy =
        this.searchData.sortBy === "DESC" ? "ASC" : "DESC";
      this.passParamUrl();
      this.getLists();
    },

    classStatusSort(column) {
      return this.searchData.sortColumn === column &&
        this.searchData.sortBy === "ASC"
        ? "sort-rotate"
        : "";
    },

    async deleteItem(overTimeRequestId) {
      this.idDelete = overTimeRequestId;
      this.visible = true;
      // this.$confirm(
      //   this.$t("popup.label_popup_text"),
      //   this.$t("popup.label_popup_title"),
      //   this.$t("popup.label_confirm_button"),
      //   this.$t("popup.label_cancel_button"),
      //   "danger"
      // ).then((value) => {
      //   if (value) {
      //     this.deleteOverTimeRequest(overTimeRequestId)
      //       .then(() => {
      //         this.getLists();
      //         this.$toast(
      //           this.$t("popup.label_popup_success_text"),
      //           null,
      //           2000,
      //           "b-toaster-top-center",
      //           "success"
      //         );
      //       })
      //       .catch(() => {
      //         this.$toast(
      //           this.$t("popup.label_popup_error_text"),
      //           null,
      //           2000,
      //           "b-toaster-top-center",
      //           "error"
      //         );
      //       });
      //   }
      // });
    },

    async confirmDelete() {
      await this.deleteOverTimeRequest(this.idDelete)
        .then(() => {
          this.getLists();
          this.visible = false;
          this.$toast(
            this.$t("popup.label_popup_success_text"),
            null,
            2000,
            "b-toaster-top-center",
            "success"
          );
          this.$store.dispatch("commons/getCountRequest");
        })
        .catch(() => {
          this.visible = false;
          this.$toast(
            this.$t("popup.label_popup_error_text"),
            null,
            2000,
            "b-toaster-top-center",
            "error"
          );
        });
    },

    formatDate(data) {
      return moment(data, "HH:mm:ss").format("HH:mm");
    },

    checkValidDate(date) {
      let subWeek = moment().subtract(8, "d").format("YYYY-MM-DD");
      return moment(subWeek).isBefore(date, "day");
    },

    getDate(date) {
      return moment(date, "YYYY-MM-DD").format("ddd");
    },

    checksubmitable()
    {
      return this.checkSubmitable.submit_period.submitable
    },

    disableMonth(current) {
      return (
        current &&
        (current > moment().endOf("day") ||
          current < moment("3/2018", "M/YYYY"))
      );
    },

    formatNumber(number) {
      return Math.round(number * 100) / 100;
    },
  },

  created() {
    window.localStorage.clear();
    this.searchData.month = moment();
    if (localStorage.statusOT) {
      this.searchData.status = localStorage.statusOT;
    }
    if (Object.keys(this.$route.query).length !== 0) {
      let params = this.$route.query;
      params.perPage =
        this.listItemsPerPage.includes(parseInt(params.perPage)) &&
        !isNaN(params.perPage)
          ? params.perPage
          : 10;

      this.searchData = {
        month:
          params.month == undefined
            ? this.searchData.month
            : moment("01/" + params.month, "DD/MM/YYYY"),
        status:
          params.status == undefined
            ? parseInt(this.searchData.status)
            : parseInt(params.status),
        itemsPerPage: params.perPage,
        sortColumn: params.sortColumn,
        sortBy: params.sortBy,
        paginate: {
          from: params.from,
          to: params.to,
          totalPage: parseInt(params.totalPage),
          path: this.searchData.paginate.path,
          currentPage: parseInt(params.currentPage),
          totalRecord: parseInt(params.totalRecord),
          perPage: parseInt(params.perPage),
        },
      };
    }
    this.getLists();
  },
  watch: {
    $route(to) {
      if (to.fullPath === "/overtime-requests") {
        this.resetParams();
        this.getLists();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.employee {
  .btn-search {
    margin-top: 28px;
    // margin-left: 36px;

    .btn-search-employee {
      background: #3d4cdc;
      height: 40px;
      width: 100%;
      max-width: 210px;
      border-radius: 10px;
      font-weight: 700;
      font-size: 14px;
      color: #ffffff;
    }
  }

  table.table td {
    margin: auto;
    padding: 0.55rem 0.75rem;

    ul {
      list-style-type: none;
      padding-left: 0px;
      margin-bottom: 0px;

      li {
        text-align: left;
      }
    }
  }

  table.table th {
    margin: auto;
  }
}

.employee-table {
  margin: 0;
  border: none;
  border-radius: 0;

  .card-body {
    padding-top: 10px;
  }

  .cl-pointer {
    cursor: pointer;

    .icon-sort {
      margin-left: 5px;

      .c-icon {
        width: 12px;
      }

      .sort-rotate {
        transform: rotate(180deg);
      }
    }
  }
}

@media screen and (min-width: 768px) and (max-width: 1024px) {
  .table {
    width: 1200px;
  }
}

@media screen and (max-width: 740px) {
  .row-mobile {
    margin-top: 30px;
  }

  .table {
    width: 1200px;
  }

  .row-btn-mobile {
    margin-bottom: 15px;
  }
}

th,
td {
  vertical-align: middle !important;
}

@media screen and (max-width: 320px) {
  .vc-popover-content-wrapper[data-v-7605e1b2].is-interactive {
    position: absolute;
    transform: translate3d(-3px, 29px, 0px) !important;
  }
}

/*-------------------------------------------------*/

.employee {
  .time-sheet__filter {
    background: #ffffff;
    padding: 19px 24px;
    margin: -2rem 0 12px 0px;

    .time-sheet__header {
      font-weight: 700;
      font-size: 18px;
      line-height: 22px;
      color: #3d4cdc;
      padding-bottom: 19px;
      border-bottom: 1px solid #eaeaea;
      margin-bottom: 19px;
    }

    .form-control {
      height: 40px;
      border-radius: 10px;
    }

    .card-table-emloyee {
      .btn-search-employee {
        height: 40px;
      }
    }

    .btn-datepicker {
      margin-top: 20px;
      width: 127px;
      font-size: 16px;
      height: 40px;
      padding: 8px;
      background: #118fa6;
      border-radius: 5px;
      color: #ffffff;
    }

    // .form-status {
    //   margin-top: -8px;
    //   width: 231px;
    //   height: 40px;
    //   background: #ffffff;
    //   border: 1px solid #dde2e5;
    //   border-radius: 5px;
    // }

    // .btn-search-employee {
    //   background-color: #b5dbf2;
    //   padding: 8px;
    //   width: 120px;
    // }
  }

  .btn-switch-link {
    cursor: pointer;
    padding: 11px 0;
    text-align: center;
    background: #ececec;
    width: 210px;
    border-radius: 10px;
    span {
      font-weight: 700;
      font-size: 14px;
      line-height: 17px;
      color: #3d4cdc;
    }
  }

  .table-wrapper {
    width: 100%;
    overflow-x: auto;
    margin-bottom: 15px;
  }
  .table-content {
    min-width: 1130px;
    width: 100%;
    border-radius: 10px;
    border-spacing: 0;
    border-collapse: separate;
    border: 1px solid #efefef;
    border-top: 0;
    overflow: hidden;

    & th:not(:last-child),
    & td:not(:last-child) {
      border-right: 1px solid #efefef;
    }

    & > thead > tr:not(:last-child) > th,
    & > thead > tr:not(:last-child) > td,
    & > tbody > tr:not(:last-child) > th,
    & > tbody > tr:not(:last-child) > td,
    & > tfoot > tr:not(:last-child) > th,
    & > tfoot > tr:not(:last-child) > td,
    & > tr:not(:last-child) > td,
    & > tr:not(:last-child) > th,
    & > thead:not(:last-child),
    & > tbody:not(:last-child),
    & > tfoot:not(:last-child) {
      border-bottom: 1px solid #efefef;
    }

    .table-header {
      background: #3488eb;
      border-radius: 10px 10px 0px 0px;

      th {
        padding: 1em;
        text-align: center;
        font-style: normal;
        font-weight: 700;
        font-size: 14px;
        line-height: 17px;
        color: #ffffff;
        border-bottom: 0 !important;
      }
    }

    .table-body {
      th {
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 17px;
        color: #303c54;
        border: 1px solid #efefef;
        vertical-align: baseline;
      }

      td {
        padding: 0.7em 0;
        height: 45px;
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 17px;
        color: #303c54;
        border: 1px solid #efefef;
        vertical-align: baseline;
        text-align: center;

        ul {
          list-style: none;
          margin: 0;
          width: 100%;
          padding: 0;

          li:first-child {
            margin-bottom: 5px;
          }
        }

        .status-content {
          font-size: 14px;
          font-weight: bold;
        }

        .color-status-1 {
          color: #f58722;
        }

        .color-status-3 {
          color: #dc1313;
        }

        .color-status-2 {
          color: #006400;
        }

        .action-btn-group {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 14px;

          .action-button {
            cursor: pointer;
            width: 34px;
            height: 34px;
            background: #efefef;
            border: 1px solid #dcdcdc;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
      }
    }
    .table-empty {
      position: absolute;
      left: 45%;
      bottom: 50px;
      opacity: 0.6;
    }
  }
}

.content {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  gap: 10px;
  p {
    margin: 0;
    font-weight: bold;
  }
}
.form-button {
  .employees-form-ot {
    display: flex;
    gap: 20px;
    .save-info {
      width: 50%;
      background: #3d4cdc;
      border-radius: 10px;
      font-weight: 700;
      font-size: 14px;
      height: 40px;
      color: #ffffff;
    }
    .cancel-employee {
      width: 50%;
      background: #ececec;
      border-radius: 10px;
      color: #6f6f6f;
      font-weight: 700;
      height: 40px;
      font-size: 14px;
    }
  }
}

@media screen and (max-width: 740px) {
  .employee .employee-table {
    margin: 0 !important;
  }

  // .cancel-employee {
  //   margin-top: 10px !important;
  // }

  .save-info {
    width: 100%;
  }

  .btn-search {
    margin-top: 15px;
    padding-right: 0 !important;
    padding-left: 0 !important;
  }

  #desktop-screen {
    display: none;
  }

  #mobile-screen {
    display: flex !important;
    margin-bottom: 10px;
  }

  .table {
    overflow: auto;
    width: 1450px;
  }

  .row-mobile {
    margin-top: 10px;
  }
}

.time-sheet__button {
  display: flex;
  align-items: center;

  .router_button {
    width: 210px;
    background: #ececec;
    border-radius: 10px;
    padding: 11px 0;
    margin-left: 10px;

    .overtime-request__create {
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: 700;
      font-size: 14px;
      color: #3d4cdc;

      img {
        margin-right: 5px;
      }
    }
  }
}
</style>

<style lang="scss">
.ant-modal-content {
  border-radius: 10px;
}

.ant-modal-header {
  background: #d2d6ff;
  border-radius: 10px 10px 0 0;
  border-bottom: 1px solid #3d4cdc;

  .ant-modal-title {
    font-size: 16px;
    font-weight: 700;
    color: #3d4cdc;
  }
}

.ant-modal-close:focus {
  outline: none;
}

.ant-modal-close-x {
  display: flex;
  width: 100%;
  align-items: center;
  margin-right: 24px;
}
.time-sheet__filter {
  .ant-input {
    height: 40px;
    border-radius: 10px;
  }
}

.select2-custom .select2-selection {
  font-size: 0.875rem;
  font-weight: 400;
  padding: 0.375rem 0.75rem;
  height: 40px;
  display: block;
  line-height: 1.5;
  background-clip: padding-box;
  border: 1px solid #d8dbe0;
  color: #768192;
  background-color: #fff;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.select2-custom .select2-selection:focus {
  color: #768192;
  background-color: #fff;
  border-color: #958bef;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(50, 31, 219, 0.25);
}

.select2-container {
  width: 100% !important;
}

.month {
  display: block;
}

.min-w-200 {
  width: 232px;
  min-width: 200px;
}

.datepicker__input {
  width: 100%;
}

th,
td {
  vertical-align: middle !important;
}

.tabs-control-overtime-request {
  // display: flex;
  padding: 0 20px;
  justify-content: space-between;
}

@media screen and (max-width: 320px) {
  .vc-popover-content-wrapper[data-v-7605e1b2].is-interactive {
    position: absolute;
    transform: translate3d(-3px, 29px, 0px) !important;
  }
}

.color-status-1 {
  span.badge.badge-secondary {
    background: #eff2f7;
    color: #f58722;
    border-radius: 73px;
    padding: 4px 10px;
    font-weight: 700;
  }
}

.color-status-3 {
  span.badge.badge-secondary {
    background: #eff2f7;
    color: #dc1313;
    border-radius: 73px;
    padding: 4px 10px;
    font-weight: 700;
  }
}

.color-status-2 {
  span.badge.badge-secondary {
    background: #eff2f7;
    color: #006400;
    border-radius: 73px;
    padding: 4px 10px;
    font-weight: 700;
  }
}

.tabs-control-overtime-request {
  height: 51px;
  padding: 0 0 10px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: none !important;
  font-weight: 400;
  font-size: 16px;
  margin-bottom: 0 !important;

  .time-sheet__header {
    font-weight: 700;
    font-size: 18px;
    color: #3d4cdc;
  }
}

.list-tabs {
  list-style-type: none;
  text-align: center;
  align-items: center;
  padding-left: 0px;
  margin-bottom: 0px;
  display: flex;
  color: #1f2d3d;

  li {
    color: #000000;
    padding: 14px 26px;
    cursor: pointer;

    &.active {
      background-color: rgba(17, 143, 166, 0.1);
      font-weight: 500;
      border-bottom: 2px solid #118fa6;
      margin-bottom: -2px;
      color: #118fa6;
    }
  }
}
</style>
